export enum VerificationEntityType {
  ADD_LATER = 'ADD_LATER',
  SELF_CERTIFYING = 'SELF_CERTIFYING',
  CERTIFYING_THIRD_PARTY = 'SELF_CERTIFYING_THIRD_PARTY',
  NON_SELF_CERTIFYING_THIRD_PARTY = 'NON_SELF_CERTIFYING_THIRD_PARTY',
}

export enum ProjectVerificationEntityReason {
  NONE = '',
  MANDATORY = 'MANDATORY',
  VOLUNTARY = 'VOLUNTARY',
  EIA_COMMITMENT = 'EIA_COMMITMENT',
  OTHERS = 'OTHERS',
}

export enum IPCC {
  NONE = '',
  AR4 = 'AR4',
  AR5 = 'AR5',
  AR6 = 'AR6',
}

export enum BoundaryInvestigationSettingRule {
  NONE = '',
  EQUITY_SHARE_APPROACH = 'EQUITY_SHARE_APPROACH',
  CONTROL_APPROACH_OP_CONTROL = 'CONTROL_APPROACH_OP_CONTROL',
  CONTROL_APPROACH_FIN_CONTROL = 'CONTROL_APPROACH_FIN_CONTROL',
}

export enum CertifyingThirdParty {
  NONE = '',
  AFNOR = 'AFNOR',
  BSI = 'BSI',
  BV = 'BV',
  DNV = 'DNV',
  LRQA = 'LRQA',
  SGS = 'SGS',
  TUVRH = 'TUVRH',
  MIRDC = 'MIRDC',
  ITRI_CMS = 'ITRI_CMS',
  TERTEC = 'TERTEC',
  ETC = 'ETC',
  PMC = 'PMC',
  TUVNORD = 'TUVNORD',
  CPC = 'CPC',
  ARES = 'ARES',
  TUVSUD = 'TUVSUD',
  KPMG = 'KPMG',
  ATRI = 'ATRI',
  DQS = 'DQS',
  AURAY = 'AURAY',
  TAIYEN = 'TAIYEN',
  FIRDI = 'FIRDI',
}

export enum ErrorCode {
  REP_001 = 'REP_001',
}

export enum StandardOfInventory {
  ISO14064_1 = 'ISO14064_1',
  GHG_ACCREDITATION_VERIFICATION = 'GHG_ACCREDITATION_VERIFICATION',
  GHG_PROTOCOL_CORPORATE_ACCOUNTING = 'GHG_PROTOCOL_CORPORATE_ACCOUNTING',
  ISO14067_2018 = 'ISO14067_2018',
  CNS14067_2021 = 'CNS14067_2021',
  PCR = 'PCR',
}
